import { z } from "zod";
import { IdPrefix, generateId } from "../utils";
import type { CompartmentType } from "./Compartment";
import { DOOR_MARGIN, DOOR_THICKNESS, DoorSchema } from "./Door";

export const MAX_DOUBLE_DOOR_WIDTH = 1200;

export const DoubleDoorSchema = z.object({
	type: z.literal("double"),
	left: DoorSchema,
	right: DoorSchema,
});

DoubleDoorSchema.refine((val) => val.left.width + val.right.width <= MAX_DOUBLE_DOOR_WIDTH, {
	message: `Double door width must be less than ${MAX_DOUBLE_DOOR_WIDTH}`,
});

type DoubleDoor = z.infer<typeof DoubleDoorSchema>;

export function createDoubleDoor(compartment: CompartmentType): DoubleDoor {
	const doorWidth = compartment.width / 2;

	return {
		type: "double",
		left: {
			id: generateId(IdPrefix.Door),
			type: "single",
			side: "left",
			x: compartment.x + DOOR_MARGIN / 2,
			y: compartment.y + DOOR_MARGIN / 2,
			z: compartment.depth - DOOR_THICKNESS,
			width: compartment.height - DOOR_MARGIN,
			height: DOOR_THICKNESS,
			depth: doorWidth - DOOR_MARGIN + 1,
		},
		right: {
			id: generateId(IdPrefix.Door),
			type: "single",
			side: "right",
			x: compartment.x + DOOR_MARGIN / 2 + doorWidth,
			y: compartment.y + DOOR_MARGIN / 2,
			z: compartment.depth - DOOR_THICKNESS,
			depth: doorWidth - DOOR_MARGIN + 1,
			height: DOOR_THICKNESS,
			width: compartment.height - DOOR_MARGIN,
		},
	};
}
